import React from "react";
import Header from "../../../../ui-components/LandingPage/Zapier/Header";
import TestimonialOne from "../../../../ui-components/LandingPage/Zapier/TestimonialOne";
import Card from "../../../../ui-components/LandingPage/Zapier/Card";
import TestimonialTwo from "../../../../ui-components/LandingPage/Zapier/TestimonialTwo";
import TestimonialThree from "../../../../ui-components/LandingPage/Zapier/TestimonialThree";
import FaqSection from "../../../../ui-components/LandingPage/Zapier/FaqSection";
import TestimonialCard from "../../../../ui-components/LandingPage/Zapier/TestimonialCard";

const Zapier = () => {
  return (
    <>
        <Header />
        <TestimonialOne />
        <TestimonialTwo />
        <TestimonialThree />
        <Card />
        <TestimonialCard />
        <FaqSection />
    </>
  );
};

export default Zapier;